import { fileURLToPath } from 'node:url'
import type { BetterstartConfigFile } from '@cli-types/core-engine/config.js'

export async function loadConfigFile(configPath: string): Promise<BetterstartConfigFile> {
  const { createJiti } = await import('jiti')

  const alias: Record<string, string> = {}
  try {
    alias['betterstart-cli'] = fileURLToPath(import.meta.resolve('betterstart-cli'))
  } catch {
    // Config files may not import from this package.
  }

  const jiti = createJiti(import.meta.url, { alias })
  const mod = await jiti.import(configPath)
  return ((mod as Record<string, unknown>).default || mod) as BetterstartConfigFile
}
